<section class="container py-5 mt-5 mb-2 mb-sm-3 mb-lg-4 mb-xxl-5">

  <h1 class="display-4 pb-3 pb-md-4 pb-lg-5">Politica de confidentialitate</h1>

  <div class="row">
    <div class="col-md-10">

      <h2 class="h1 pb-2">I. Securitate si date cu caracter personal</h2>
      <p>Incepand cu data de 25 mai 2018, in ceea ce priveste protectia datelor cu caracter personal, vor deveni
        aplicabile
        reglementarile
        <i>Regulamentului (UE) 2016/679 al Parlamentului European si al Consiliului din 27 aprilie 2016 privind
          protectia
          persoanelor fizice in ceea ce priveste prelucrarea datelor cu caracter personal si privind libera
          circulatie
          a acestor date si de abrogare a Directivei 95/46/CE (Regulamentul general privind protectia datelor -
          GDPR).</i>
      </p>
      <p>
        <strong>IT INNOVATION CORP S.R.L.</strong> („Intermediarul” avand calitatea de Operator), in sensul definit
        de Regulament, este organizata sub forma unei societati cu raspundere limitata, care detine si opereaza
        portalul
        web
        <a href="https://www.giftshare.ro">www.giftshare.ro</a>, In exercitarea acestui obiect de activitate,
        <strong>IT INNOVATION CORP S.R.L.</strong> colecteaza, proceseaza si stocheaza date cu caracter personal si,
        in unele cazuri exceptionale, bine definite si cu un scop precis, date cu caracter special.
      </p>
      <p>Datele Operatorului sunt:</p>
      <p>Societatea
        <strong>IT INNOVATION CORP S.R.L.</strong>, cu sediul social in Mun. Bucuresti, Bld. Tineretului (fosta Str.
        Pionierilor) nr. 49, bl. 58, sc. 2, et. 1, ap. 40, sector 4, CUI 37773927, Nr. Reg. Com. J40/ 9405/ 2017;
        adresa
        de e-mail: contact&#64;giftshare.ro;
      </p>
      <p>Datele autoritatii de supraveghere compentente:</p>
      <p>Autoritatii Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal (A.N.S.P.D.C.P.)</p>
      <p>B-dul G-ral. Gheorghe Magheru 28-30</p>
      <p>Sector 1, cod postal 010336</p>
      <p>Bucuresti, Romania</p>
      <p>Tel.: +40.318.059.211/ +40.318.059.212</p>
      <p>Adresa de e-mail: anspdcp&#64;dataprotection.ro</p>
      <p>Site web: www.dataprotection.ro</p>

      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">II. Conditii de prelucrare a datelor cu caracter personal</h2>
      <p>Prelucarea de date cu caracter personal de catre Operator se realizeaza in urmatoarele conditii:</p>
      <p>Avand in vedere profilul de activitate al Operatorului, exista posibilitatea sa solicitam si sa prelucram
        urmatoarele
        categorii de date cu caracter personal, definite potrivit Regulamentului: </p>
      <ol>
        <li>Numele si prenumele persoanei fizice;
        </li>
        <li>Codul numeric personal;</li>
        <li>Adresa de domiciliu precum si orice alte adrese de corespondenta pe care membrii inregistrati le pun la
          dispozitia
          Operatorului in scopul prelucrarii; </li>
        <li>Seria si numarul cartii de identitate, a pasaportului, a permisului de sedere, precum si echivalentul
          acestor
          informatii, in functie de tipul documentului de identitate prezentat; </li>
        <li>Adresa de e-mail, precum si orice alte adrese de e-mail pe care membrii inregistrati le pun la
          dispozitia Operatorului
          in scopul prelucrarii; </li>
        <li>Alte date cu caracter personal. </li>
      </ol>

      <p>Colectarea datelor cu caracter sau special se realizeaza prin:</p>
      <ol>
        <li>Inregistrarea pe portal web
          <a href="https://www.giftshare.ro">www.giftshare.ro</a>;
        </li>
        <li>Receptionarea de date/informatii prin e-mail sau alte forme de mesagerie electronica;</li>
        <li>Furnizarea de catre Client a datelor cu caracter personal sau special prin orice mijloace; </li>
        <li>Alte mijloace care decurg in mod rezonabil din exercitarea obliectului de activitate.</li>
      </ol>
      <p>Scopurile colectarii datelor cu caracter personal si/sau special de catre Operator sunt urmatoarele: </p>
      <ol>
        <li>Inregistrarea in cadrul platformei; </li>
        <li>Intocmirea facturilor, chitantelor, precum si a oricaror alte documente cu caracter financiar-fiscal
          pentru
          care legea impune utilizarea unor date cu caracter personal; </li>
        <li>Furnizatea de informatii minime partenerilor vanzatori strict in vederea furnizarii
          voucherelor/cardurilor
          si/sau ofertelor personalizate;
        </li>
        <li>Intocmirea de catre Operator a unei evidente informatice proprii de gestiune a clientilor, prin
          utilizarea
          unor programe informatice specifice, precum: Microsoft Excel, Microsoft Word, etc., precum si incarcarea
          acestora pe serverul propriu sau inchiriat, in scopul limitat de a gestiona propriile resurse; Aceste
          programe
          informatice, precum si cele utilizate pe viitor de catre Operator sunt detinute in mod legal si detin
          garantii
          si sisteme de securizare proprii; pentru mai multe detalii va rugam sa vizitati portalurile web ale
          producatorilor,
          in sectiunile destinate securitatii si datelor cu caracter personal; </li>
        <li>Comunicari catre membrii in stransa legatura cu evenimentele in curs si la care partile interesate sunt
          parte;
        </li>
        <li>Orice alt scop pentru care membrii inregistrati si-au manifestat consimtamantul liber consimtit, in mod
          expres,
          ulterior prezentei informari.</li>
      </ol>

      <p>Pentru receptionarea de comunicari periodice sub forma de informari generale in stransa legatura cu
        obiectul
        de activitate al Operatorului, membriilor inregistrati li se va solicita consimtamantul in mod expres, o
        singura
        data, la inregistrarea in platforma, urmand ca in cazul in care va dispune stergerea contului sau va formula
        o cerere expresa, aceste comunicari sa nu-i mai fie transmise. </p>
      <p>Intermediarul, in calitate de Operator va transfera date cu caracter personal catre Vanzatori, in calitate
        de
        parteneri, strict in scopul emiterii de catre acestia a documentelor financiar-contabile pe numele
        Beneficiarilor,
        in caliatate de persoane vizate, Beneficiarul intelegand si asumandu-si ca acest transfer este de esenta
        serviciilor
        prestate de catre Intermediar. </p>
      <p>In procesul de prestare a serviciilor Operatorul declara ca: </p>
      <ol>
        <li>Nu va utiliza datele cu caracter personal sau special ale membrilor in alte scopuri decat cele
          comunicate in
          mod expres acestuia, urmand ca pentru orice prelucrare care excede scopurilor enumerate mai sus Operatorul
          sa solicite consimtamantul expres, in scris, a membrului in cauza;</li>
        <li>Va pastra confidentialitatea deplina cu privire la datele cu caracter personal si/sau special ale
          membrilor
          in relatia cu tertii, cu exceptia scopurilor care rezulta din exercitarea obiectului de activitate, pentru
          care membrii si-au manifestat consimtamantul in mod expres prin acceptarea termenelor si conditiilor;</li>
        <li>Datele cu caracter personal si/sau special prelucrate de catre Operator vor fi stocate astfel:
          <ul>
            <li>pe dispozitivele informatice apartiand personalului Operatorului, conectate la internet;</li>
            <li>pe serverul care gazduieste portalul web
              <a href="https://www.giftshare.ro">www.giftshare.ro</a>;
            </li>
            <li>pe dispozitivele mobile utilizate de catre personalul Operatorului ca urmare a utilizarii adreselor
              de
              e-mail pe aceste dispozitive;</li>
            <li>pe suport fizic (imprimat), in arhiva Operatorului, daca este cazul.</li>
          </ul>
        </li>
        <li>Operatorul va pastra arhivele pentru o perioada ce nu va fi mai scurta de data incetarii raportului
          juridic.
          Fac exceptie documentele care cuprind date cu caracter personal si/sau special pentru care legea instituie
          obligatia pastrarii lor pentru o durata de timp determinata, superioara sau inferioara perioadei declarate
          de catre Operator; oricum, in masura in care procesarea si stocarea datelor cu caracter personal nu se mai
          justifica in mod rezonabil, Operatorul va lua toate masurile necesare stergerii sau distrugerii acestora,
          dupa caz, in conditii de confidentialitate si securitate optime;</li>
        <li>La datele cu caracter personal si/sau special prelucrate de catre Operator vor avea acces:
          <ul>
            <li>asociatii si administratorii, consiliul director ai operatorului; </li>
            <li>personalul cu atributiuni in gestionarea platformei si a bazelor de date, membrii departamentelor IT
              si
              contabilitate;
            </li>
            <li>autoritatile publice cu atributiuni de cercetare si/sau control, in exercitarea prerogativelor
              acestora
              conferite de lege; </li>
            <li>entitatile terte, cu personal propriu sau colaborator, care intra in posesia documentelor cuprinzand
              date
              cu caracter personal si/sau special in stricta exercitare a obiectului de activitate; </li>
            <li>institutiile bancare sau financiare nebancare in masura in care documentele cuprinzand date cu
              caracter
              personal sau special necesita o raportare catre acestea in scopul de a accesa linii de credit sau alte
              produse bancare sau financiare. </li>
          </ul>
        </li>
        <li>Operatorul ia toate masurile necesare in legatura cu activitatea proprie, ca informatiile cu caracter
          personal
          si/sau special sa beneficieze de protectia impusa prin Regulament. Nicio alta persoana, cu exceptia celor
          enumerate mai sus nu vor beneficia de acces la datele cu caracter personal. Totusi, in cazul in care
          Operatorul
          sesizeaza o situatie in care date cu caracter personal sau special ale membrilor au ajuns in posesia altor
          persoane decat cele autorizate, va lua toate masurile privind informarea a acestora si/sau a Autoritatii
          Nationala de Supraveghere a Prelucrarii Datelor cu Caracter Personal (A.N.S.P.D.C.P.) potrivit
          Regulamentului;</li>
      </ol>
      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">III. Dreptul membrilor de a solicita informatii sau actiuni din partea Operatorului</h2>
      <p>Oricand pe perioada prelucrari si/sau stocarii datelor cu caracter personal sau special, membrii au
        dreptul:
      </p>
      <ol>
        <li>De a solicita Operatorului, in scris, informatii cu privire la datele cu caracter personal prelucrate,
          pe care
          Operatorul le detine, precum si durata de timp in care aceste date se vor afla in posesia Operatorului in
          scopul prelucrarii sau stocarii; </li>
        <li>De a solicita stergerea datelor cu caracter personal sau special, prelucrate de catre Operator, din
          evidentele,
          arhivele, dispozitivele acestuia, oricand pe perioada de desfasurare a raporturilor contractuale, sub
          rezerva
          neafectarii serviciilor prestate, precum si cu mentiunea ca informatiile ajunse in posesia tertilor, cu
          respectarea
          Regulamentului si a prezentului acord, nu pot fi retractate si nu mai fac obiectul unei obligatii a
          Operatorului;
        </li>
        <li>Dreptul „de a fi uitat” consacrat de Regulament, in virtutea caruia mrmbrii pot solicita
          stergerea/distrugerea
          si/sau restituirea documentelor/ informatiilor care cuprind date cu caracter personal si/sau special, cu
          exceptia documentelor si/sau informatiilor transferate catre terti in conditiile Regulamentului si a
          termenelor
          si conditiilor sau pentru care Operatorul are o obligatie legala de pastrare, precum dar fara sa ne
          limitam
          la: facturi, chitante, registre contabile;</li>
        <li>Dreptul de a solicita Operatorului confirmarea, in scris, a conformarii acestuia la cerintele formulate
          de
          catre membrii; in acest sens, mentionam ca Operatorul este obligat sa raspunda solicitarii acestora in
          termen
          de cel mult 30 zile, cu exceptiile prevazute de Regulament. </li>
      </ol>
      <h2 class="h1 pt-3 pt-sm-4 pt-xl-5 pb-2">IV. Date de contact</h2>
      <p>Pentru a va exercita drepturile legate de Datele dumneavoastra cu Caracter Personal care au fost colectate,
        trimiteti un e-mail la adresa Responsabilului cu Protectia Datelor din cadrul GiftShare
        <strong>dataprotection&#64;giftshare.ro</strong>.
      </p>
      <p>Pentru a putea sa raspundem solicitarii dumneavoastre, va trebui sa ne comunicati urmatoarele date de
        identificare necesare: nume, prenume, e-mail sau adresa postala si orice alte informatii necesare pentru a
        va confirma identitatea. </p>
      <p>Vom procesa cererea dvs. in cel mai scurt timp posibil, dar ne rezervam un termen de 30 de zile, calculat
        de la momentul primirii solicitarii, pentru a va raspunde.</p>


    </div>
  </div>

</section>
